export default __webpack_public_path__ + "static/image2-e6ce4626cb12fcc0aab141d43ba33d09.png";